/**
 * استایل مشترک نویگیشن پایین موبایل در هر سه بخش (فروشگاه، مجله، سلر آکادمی).
 * ظاهر نوار باید در همه‌ی بخش‌ها دقیقا یکی باشد؛ پس کلاس‌ها فقط همین‌جا تعریف
 * می‌شوند و هیچ نسخه‌ای نباید کلاس مخصوص خودش را داشته باشد.
 */
export const FOOTER_NAV_BAR_CLASS =
	"flex justify-between items-center fixed bottom-0 left-0 right-0 bg-white border-t border-neutral-200 py-2.5 px-4 z-30";

export const footer_nav_item_class = (active) =>
	`relative flex flex-col items-center gap-1 text-xs ${active ? "text-jmt-neutral-900 font-bold" : "text-neutral-500"}`;
